<template>
  <div class="m-timeline-1__item">
    <div class="m-timeline-1__item-circle">
      <div class="m--bg-danger"></div>
    </div>
    <div class="m-timeline-1__item-arrow"></div>
    <div class="m-timeline-1__item-time font-ls" :class="[shouldBreakType && 'break-margin']">
      <span v-if="type"
            class="font-ls space-nowrap pl-0 pr-2"
            v-encode="type"
            :class="[isMobile && shouldBreakType && 'ellipsis-mobile']"></span>
      <br v-if="shouldBreakType">
      <span class="m--font-metal space-nowrap pl-0">{{ date | moment('DD.MM.YYYY HH:mm') }}</span>
    </div>
    <div class="m-timeline-1__item-content">
      <div class="m-timeline-1__item-title break-word">
        <slot name="title"></slot>
      </div>
      <div class="m-timeline-1__item-body mt-0">
        <slot name="body"></slot>
      </div>
      <div class="m-timeline-1__item-actions empty-mt-0 text-center">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Encode from '@/directives/encode';
import Screen from '@/mixins/screen';

export default {
  name: "TimelineItem",
  props: {
    type: String,
    date: String,
  },
  directives: {
    Encode,
  },
  mixins: [
    Screen,
  ],
  computed: {
    shouldBreakType() {
      return this.isMobile && this.type.length > 20;
    }
  }
}
</script>

<style scoped>
.break-word {
  word-wrap: break-word;
}

.m-timeline-1__item-content {
  max-width: 350px;
}

@media screen and (max-width: 330px) {
  .m-timeline-1__item-content {
    padding: 1.35rem !important;
  }
}

.space-nowrap {
  white-space: nowrap;
}

.empty-mt-0:empty {
  margin-top: 0 !important;
}

.break-margin {
  margin-top: -3.4rem !important;
}

.m-timeline-1__item:only-of-type {
  margin-bottom: 4rem;
}

.ellipsis-mobile {
  width: 55vw;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: -6px;
}

@media (max-width: 1199px) {
  .m-timeline-1 .m-timeline-1__items .m-timeline-1__item.m-timeline-1__item--first + .m-timeline-1__item--right {
    margin-top: 9.5rem !important;
  }
}
</style>
